<div class="modal-header">
  <h5 class="modal-title text-center ml-auto mr-auto">Select Your Desired Rating</h5>
  <button (click)="modalService.closeOutletModals('public')" type="button" class="close" data-dismiss="modal" aria-label="Close">
    <svg-selector [svgName]="'close-small'" [svgColor]="'#ffffff'"></svg-selector>
  </button>
</div>
<div class="modal-body">

  <div class="row" style="font-style: italic;text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.75);">
    <div class="col-md text-center">
      <div class="title-wrapper rank-wrapper">
        <cs2-svg-selector [rankValue]="0"></cs2-svg-selector>
        <span>5,000-</span>
      </div>
      <div class="rank-wrapper">
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('1000','cs2'))"><span style="font-size: 30px;">1</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('2000','cs2'))"><span style="font-size: 30px;">2</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('3000','cs2'))"><span style="font-size: 30px;">3</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('4000','cs2'))"><span style="font-size: 30px;">4</span>,000</div>
      </div>
    </div>

    <div class="col-md text-center" style="color:#98b4cb">
      <div class="title-wrapper rank-wrapper">
        <cs2-svg-selector [rankValue]="5"></cs2-svg-selector>
        <span>5,000+</span>
      </div>
      <div class="rank-wrapper">
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('5000','cs2'))"><span style="font-size: 30px;">5</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('6000','cs2'))"><span style="font-size: 30px;">6</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('7000','cs2'))"><span style="font-size: 30px;">7</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('8000','cs2'))"><span style="font-size: 30px;">8</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('9000','cs2'))"><span style="font-size: 30px;">9</span>,000</div>
      </div>
    </div>

    <div class="col-md text-center" style="color:#89aced">
      <div class="title-wrapper rank-wrapper">
        <cs2-svg-selector [rankValue]="10"></cs2-svg-selector>
        <span>10,000+</span>
      </div>
      <div class="rank-wrapper">
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('10000','cs2'))"><span style="font-size: 30px;">10</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('11000','cs2'))"><span style="font-size: 30px;">11</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('12000','cs2'))"><span style="font-size: 30px;">12</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('13000','cs2'))"><span style="font-size: 30px;">13</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('14000','cs2'))"><span style="font-size: 30px;">14</span>,000</div>
      </div>
    </div>

    <div class="col-md text-center" style="color:#c183d9">
      <div class="title-wrapper rank-wrapper">
        <cs2-svg-selector [rankValue]="15"></cs2-svg-selector>
        <span>15,000+</span>
      </div>
      <div class="rank-wrapper">
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('15000','cs2'))"><span style="font-size: 30px;">15</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('16000','cs2'))"><span style="font-size: 30px;">16</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('17000','cs2'))"><span style="font-size: 30px;">17</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('18000','cs2'))"><span style="font-size: 30px;">18</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('19000','cs2'))"><span style="font-size: 30px;">19</span>,000</div>
      </div>
    </div>

    <div class="col-md text-center" style="color:#f26ef3">
      <div class="title-wrapper rank-wrapper">
        <cs2-svg-selector [rankValue]="20"></cs2-svg-selector>
        <span>20,000+</span>
      </div>
      <div class="rank-wrapper">
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('20000','cs2'))"><span style="font-size: 30px;">20</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('21000','cs2'))"><span style="font-size: 30px;">21</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('22000','cs2'))"><span style="font-size: 30px;">22</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('23000','cs2'))"><span style="font-size: 30px;">23</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('24000','cs2'))"><span style="font-size: 30px;">24</span>,000</div>
      </div>
    </div>

    <div class="col-md text-center" style="color:#f56868">
      <div class="title-wrapper rank-wrapper">
        <cs2-svg-selector [rankValue]="25"></cs2-svg-selector>
        <span>25,000+</span>
      </div>
      <div class="rank-wrapper">
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('25000','cs2'))"><span style="font-size: 30px;">25</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('26000','cs2'))"><span style="font-size: 30px;">26</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('27000','cs2'))"><span style="font-size: 30px;">27</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('28000','cs2'))"><span style="font-size: 30px;">28</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('29000','cs2'))"><span style="font-size: 30px;">29</span>,000</div>
      </div>
    </div>

    <div class="col-md text-center" style="color:#f9e96d">
      <div class="title-wrapper rank-wrapper">
        <cs2-svg-selector [rankValue]="30"></cs2-svg-selector>
        <span>30,000+</span>
      </div>
      <div class="rank-wrapper">
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('30000','cs2'))"><span style="font-size: 30px;">30</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('31000','cs2'))"><span style="font-size: 30px;">31</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('32000','cs2'))"><span style="font-size: 30px;">32</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('33000','cs2'))"><span style="font-size: 30px;">33</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('34000','cs2'))"><span style="font-size: 30px;">34</span>,000</div>
      <div class="rank-select-item" (click)="onSelect(divisionService.getValueByRank('35000','cs2'))"><span style="font-size: 30px;">35</span>,000</div>
      </div>
    </div>

  </div>

</div>
